export default __webpack_public_path__ + "static/font-eeb9ef1aab7ee0f4ba3f7e0a3ccf8d37.ttf";